import styles from './Hr.module.scss';

export const Hr = () => (
  <span className={styles.hr}></span>
);
